var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h1',{staticClass:"header__heading"},[_vm._v(_vm._s(_vm.$t("reports")))])])}
var staticRenderFns = []

export { render, staticRenderFns }